import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import { axiosInstance_user } from "../../axiosInstance-user";
import { ToastContainer, toast } from "react-toastify";
import Preloader from "../../Components/Preloader";

let userSchema = yup.object({
  username: yup
    .string()
    .required("Mobile Number Required & contains 10 digits only"),
  password: yup.string().required("Password Required"),
});

function Login() {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: userSchema,

    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        // console.log("Form Submitted Values:", values);
        const { data } = await axiosInstance_user.post("/admin-login", values);
        // console.log("API Response:", data);
        const token = data.token;
        const user = data.user;

        // localStorage.setItem("token", token);
        // localStorage.setItem("user", JSON.stringify(user));
         sessionStorage.setItem("token", token);
        sessionStorage.setItem("user", JSON.stringify(user));
        toast.success(data.message || "Login Successfully!");

        resetForm();
        setLoading(false);
        setTimeout(() => {
          navigate("/dashboard");
        }, 1000);
      } catch (error) {
        console.error("Login error:", error);
        toast.error("Submission failed! Please try again.");
        setLoading(false);
      } finally {
        setLoading(false);
      }
    },
  });

  // useEffect(() => {
  //   document.addEventListener("keydown", handleEnterKey);
  //   return () => {
  //     document.removeEventListener("keydown", handleEnterKey);
  //   };
  // }, []);

  // function handleEnterKey(e) {
  //   if (e.key === "Enter") {
  //     e.preventDefault(); 
  //     formik.handleSubmit();
  //   }
  // }

  return (
    <>
      <ToastContainer />
      {loading && <Preloader />}
      <div className="login-container">
        <div className="login-subcontainer">
          <div className="login-logo">
            <img src={logo} alt="Logo" />
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="login-field">
              <label for="username">Mobile Number</label>
              <div>
                <input
                  type="text"
                  id="username"
                  autoComplete="off"
                  value={formik.values.username}
                  placeholder="Enter Mobile Number"
                  onChange={formik.handleChange}
                  // onKeyDown={handleEnterKey}
                />
                {formik.touched.username && formik.errors.username && (
                  <div className="formError">{formik.errors.username}</div>
                )}
              </div>
            </div>
            <div className="login-field">
              <label for="password">Password</label>
              <div>
                <input
                  type="password"
                  id="password"
                  autoComplete="off"
                  value={formik.values.password}
                  placeholder="Enter Password"
                  onChange={formik.handleChange}
                  // onKeyDown={handleEnterKey}
                />
                {formik.touched.password && formik.errors.password && (
                  <div className="formError">{formik.errors.password}</div>
                )}
              </div>
            </div>
            <div className="btnLogin">
              <button type="submit">Login</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
